import { i18n } from '@boot/i18n.js';

export const methodTypeToLabel = {
    email: i18n.global.t('Email'),
    app: i18n.global.t('Authenticator App')
};
